// API Consumer header for backend identification
export const HOMEBODY_ADMIN_X_CONSUMER_HEADER = 'homebody-admin-ui'

// Default API timeout in milliseconds
export const API_TIMEOUT = parseInt(import.meta.env.VITE_API_TIMEOUT || '30000', 10)

// Retry configuration
export const API_RETRY_ATTEMPTS = 3
export const API_RETRY_DELAY = 1000

// Cache configuration
export const DEFAULT_STALE_TIME = 5 * 60 * 1000 // 5 minutes
export const DEFAULT_GC_TIME = 10 * 60 * 1000 // 10 minutes

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
  },
  PROPERTIES: {
    LIST: '/properties',
    DETAIL: (id: number) => `/properties/${id}`,
    SETTINGS: (id: number) => `/properties/${id}/settings`,
  },
} as const

// HTTP status codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
} as const

// Error messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error occurred. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied. You do not have permission for this resource.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION_ERROR: 'Invalid data provided. Please check your input.',
  SERVER_ERROR: 'An internal server error occurred. Please try again later.',
  TIMEOUT: 'Request timed out. Please try again.',
} as const
